document.addEventListener('DOMContentLoaded', () => {
	const form = document.querySelector('.buchung form');
	if (!form) return;

	const radios = form.querySelectorAll('.radio input[type="radio"]');
	const datum = form.querySelector('#Datum');
	const dauer = form.querySelector('.duration .option');
	const classic = form.querySelector('.classic');
	const features = form.querySelector('.summary .features');
	const price = form.querySelector('.summary .price');
	const more = form.querySelector('.more');
	if (!radios.length || !datum || !dauer) return;

	const infos = radio => JSON.parse(radio.dataset.infos || '[]');
	if (classic) classic.hidden = true;

	const formatDate = date => new Date(`${date}T00:00:00`).toLocaleDateString('de-DE', {day: '2-digit', month: 'long'}).replace('.', '.');

	const render = (radio, reset = true) => {
		const data = infos(radio);
		if (reset) datum.innerHTML = '<option value="" disabled selected>bitte wählen</option>' + data.map(item => {
			const days = parseInt(item.dauer, 10);
			const duration = days ? ` – ${days} ${days === 1 ? 'Tag' : 'Tage'}` : '';
			const label = `${formatDate(item.datum)}${item.headline ? ' – '+item.headline : ''}${duration}`;
			return `<option value="${label}" data-date="${item.datum}">${label}</option>`;
		}).join('');

		const item = data.find(item => item.datum === datum.selectedOptions[0]?.dataset.date);
		if (classic) {
			classic.href = item?.booking || '';
			classic.target = '_blank';
			classic.hidden = !item?.booking;
		}
		if (features) features.innerHTML = '';
		if (price) price.textContent = '';

		const days = item ? parseInt(item.dauer, 10) : 0;

		const updateSummary = () => {
			const selectedDays = parseInt(form.querySelector('input[name="Tage"]:checked')?.dataset.days || 0, 10);
			const basePrice = parseFloat(String(item?.preis || 0).replace(',', '.'));

			if (features) features.innerHTML = (item?.features || []).map(feature => `<div class="feature"><span class="material">${feature.icon}</span> ${feature.name}</div>`).join('');
			if (price) price.textContent = basePrice && selectedDays ? `ab ${(basePrice * selectedDays).toLocaleString('de-DE')} €` : '';
		};

		dauer.innerHTML = Array.from({length: days}, (_, index) => {
			const day = index + 1;
			const label = day === 1 ? '1 Tag' : `${day} Tage`;
			return `<span><input type="radio" id="Tage${day}" name="Tage" value="${label}" data-days="${day}"${day === 1 ? ' required' : ''}><label for="Tage${day}">${label}</label></span>`;
		}).join('');

		dauer.querySelectorAll('input[name="Tage"]').forEach(input => input.addEventListener('change', updateSummary));
	};

	radios.forEach(radio => radio.addEventListener('change', () => {
		render(radio);
		more?.classList.add('open');
	}));
	datum.addEventListener('change', () => render(form.querySelector('.radio input:checked'), false));

});
